// ── 홈 (기능 카드 런처 페이지, 2026-08-26 A안) ─────────────────────────────────
// 상황판에 섞여 있던 기능 카드 런처를 독립 페이지로 분리 (사용자 확정 A안):
//   홈 = "어디로 갈까" (검색 + 카테고리 탭 + 보유 기능 카드) — 로그인 직후 랜딩(데스크톱).
//   상황판 = "지금 상태가 어때" (데이터 위젯 전용 모니터링).
// 카드 목록은 FeatureLauncher 가 뷰어의 사이드바 메뉴 그대로 권한 필터로 구성한다.
import React from 'react';
import { useIsMobile } from '../situationboard/utils';
import { FeatureLauncher } from '../situationboard/FeatureLauncher';
import { STD_HEADER_TOP } from '../adminlayout/designStandard';

export default function AdminHome() {
  const isMobile = useIsMobile();
  return (
    <div className="max-w-[1400px]">
      {/* 헤더 — 통일 기준(직원 관리) 반영: 두께 700, 데스크톱 시작 높이 STD_HEADER_TOP (2026-09-28) */}
      <div className={isMobile ? 'pt-1 mb-4' : 'mb-4'} style={isMobile ? undefined : { marginTop: STD_HEADER_TOP }}>
        <h2 className={`m-0 font-bold text-[var(--text)] tracking-tight uppercase ${isMobile ? 'text-2xl' : 'text-[26px]'}`}>Home</h2>
        <div className="mt-1 text-[12px] text-[var(--text-muted)]">사용할 기능을 찾아 바로 이동하세요.</div>
      </div>
      <FeatureLauncher isMobile={isMobile} />
    </div>
  );
}
